module.exports = __webpack_public_path__ + "files/4e41558f17675be76c2c2ffcfedd4145.png";